import { createI18n } from 'vue-i18n';

export type EntrLocale = 'nl' | 'en';

export const DEFAULT_LOCALE: EntrLocale = 'nl';

export const messages = {
  nl: {
    common: {
      help: 'Help',
      helpCalled: 'Hulp wordt opgeroepen',
      back: 'Terug',
      less: 'Minder',
      more: 'Meer',
      close: 'Sluiten',
      retry: 'Opnieuw proberen',
      exit: 'Afsluiten',
      confirm: 'Bevestigen',
    },
    language: {
      nl: 'Nederlands',
      en: 'English',
    },
    idleModal: {
      heading: 'Ben je er nog?',
      continueButton: 'Tik om door te gaan',
      countdownLabel: 'Terug naar start over {seconds}s',
    },
    attract: {
      headline: 'Zie je je foto?',
      groupsLabel: "Foto's",
      subhead: "Tik erop om alle foto's te zien",
      scanFallback: 'Zie je je foto niet? Scan je QR',
      loading: 'Even laden...',
    },
    scan: {
      title: 'Scan je ticket',
      body: 'Houd je Fever ticket QR voor de scanner',
      help: 'Tik op terug als je QR niet werkt',
      checking: 'Even controleren...',
    },
    selection: {
      subtitle: "Selecteer foto's",
      groupPhoto: 'Groepsfoto',
      portraits: 'Portretten',
      selectedShort: '{count} geselecteerd',
      selectedWithPrice: '{count} geselecteerd · {price} per stuk',
      total: 'Totaal',
      print: 'Printen',
      selectedZero: "Selecteer foto's om door te gaan",
      selectedOne: '1 foto geselecteerd',
      selectedMany: "{count} foto's geselecteerd",
      voucherNote: 'Je betaalt dit met je voucher.',
      voucherPartial:
        '{covered} van {total} betaald met je voucher · nog {due} te betalen',
    },
    payment: {
      title: 'Betaal via de pinautomaat',
      waiting: 'Wacht op bevestiging',
      voucherFullyCovered: 'Je betaalt dit met je voucher',
      voucherPartial: 'Voucher: -{discount} · nog {due} te betalen',
      voucherInvalid: 'Voucher niet geldig',
    },
    printing: {
      title: "Je foto's worden nu afgedrukt",
      step1: "Pak je foto's uit het bakje",
      step2: 'Pak een fotolijstje uit de mand',
      step3: 'Geniet van je herinnering!',
      eta: 'Klaar in ongeveer 30 seconden',
    },
    farewell: {
      title: 'Hopelijk zien we je snel weer!',
    },
    errors: {
      groupsLoadTitle: 'Groepen laden lukt niet',
      groupsLoadBody: 'Probeer het opnieuw of vraag een medewerker om hulp.',
      photosNotReadyTitle: "Foto's zijn nog niet klaar",
      photosNotReadyBody: 'Wacht even en scan je ticket straks opnieuw.',
      ticketNotFoundTitle: 'Ticket niet gevonden',
      ticketNotFoundBody:
        'Controleer je ticket of vraag een medewerker om hulp.',
      networkErrorTitle: 'Verbinding mislukt',
      networkErrorBody: 'Probeer het opnieuw of vraag een medewerker om hulp.',
      paymentFailedTitle: 'Betaling mislukt',
      paymentFailedBody: 'Probeer het opnieuw of vraag een medewerker om hulp.',
      paymentDeclinedTitle: 'Kaart geweigerd',
      paymentDeclinedBody: 'De kaart is geweigerd. Probeer een andere kaart.',
      paymentInsufficientFundsTitle: 'Onvoldoende saldo',
      paymentInsufficientFundsBody:
        'Er staat niet genoeg saldo op de kaart. Probeer een andere kaart.',
      paymentCardExpiredTitle: 'Kaart verlopen',
      paymentCardExpiredBody: 'De kaart is verlopen. Probeer een andere kaart.',
      paymentPinRequiredTitle: 'Steek je kaart in',
      paymentPinRequiredBody:
        'Deze kaart vraagt je pincode. Probeer opnieuw, steek de kaart in de pinautomaat en voer je pincode in.',
      paymentCardNotAcceptedTitle: 'Kaart niet geaccepteerd',
      paymentCardNotAcceptedBody:
        'Je kunt deze kaart hier niet gebruiken. Probeer een andere kaart.',
      paymentNotCompletedTitle: 'Betaling niet voltooid',
      paymentNotCompletedBody:
        'De betaling is niet voltooid. Probeer het opnieuw.',
      paymentReaderUnavailableTitle: 'Pinautomaat niet beschikbaar',
      paymentReaderUnavailableBody:
        'De pinautomaat is niet beschikbaar. Vraag een medewerker om hulp.',
      paymentTimeoutTitle: 'Geen betaalresultaat',
      paymentTimeoutBody:
        'De pinautomaat gaf niet op tijd een resultaat. Probeer het opnieuw.',
      paymentSessionUnavailableTitle: "Foto's niet beschikbaar",
      paymentSessionUnavailableBody:
        "De foto's van deze groep zijn niet beschikbaar. Vraag een medewerker om hulp.",
      paymentRetryExhaustedTitle: 'Betaling lukt niet',
      paymentRetryExhaustedBody: 'Vraag een medewerker om hulp.',
      printFailedTitle: 'Printen lukt niet',
      printFailedBody:
        'Vraag een medewerker om de printopdracht te controleren.',
      printFailedPaidBody:
        'We hebben je betaling ontvangen. Vraag een medewerker om hulp.',
      printPartialTitle: "{printed} van {total} foto's geprint",
      printRefundedBody: 'We hebben {amount} teruggestort op je kaart.',
      printNotChargedBody: '{amount} is niet in rekening gebracht.',
      printRefundedNotChargedBody:
        'We hebben {refunded} teruggestort op je kaart. {notCharged} is niet in rekening gebracht.',
      printRetryExhaustedTitle: 'Printen lukt niet',
      printRetryExhaustedBody: 'Vraag een medewerker om hulp.',
      printTimeoutTitle: 'Tijdens het afdrukken ging er iets mis',
      printTimeoutBody: 'Vraag een medewerker om hulp.',
      printTimeoutRetryBody:
        'De printer gaf niet op tijd een resultaat. Probeer het opnieuw of vraag een medewerker om hulp.',
    },
    fatal: {
      title: 'Kiosk is opnieuw aan het starten',
      subtitle: 'Een moment geduld.',
      reload: 'Opnieuw laden',
      staffTitle: 'Tik om een medewerker te roepen',
      staffSubtitle: 'De kiosk heeft hulp nodig. Vraag een medewerker om hulp.',
      misconfiguredTitle: 'Kiosk is verkeerd geconfigureerd',
      misconfiguredSubtitle: 'Vraag een medewerker om hulp.',
    },
    system: {
      reconnecting: 'Verbinding herstellen…',
    },
  },
  en: {
    common: {
      help: 'Help',
      helpCalled: 'Calling for help',
      back: 'Back',
      less: 'Less',
      more: 'More',
      close: 'Close',
      retry: 'Try again',
      exit: 'Exit',
      confirm: 'Confirm',
    },
    language: {
      nl: 'Nederlands',
      en: 'English',
    },
    idleModal: {
      heading: 'Are you still here?',
      continueButton: 'Tap to continue',
      countdownLabel: 'Returning to start in {seconds}s',
    },
    attract: {
      headline: 'Do you see your photo?',
      groupsLabel: 'Photos',
      subhead: 'Tap it to see all photos',
      scanFallback: "Don't see your photo? Scan your QR",
      loading: 'Loading...',
    },
    scan: {
      title: 'Scan your ticket',
      body: 'Hold your Fever ticket QR in front of the scanner',
      help: "Tap back if your QR doesn't work",
      checking: 'Checking...',
    },
    selection: {
      subtitle: 'Select photos',
      groupPhoto: 'Group photo',
      portraits: 'Portraits',
      selectedShort: '{count} selected',
      selectedWithPrice: '{count} selected · {price} each',
      total: 'Total',
      print: 'Print',
      selectedZero: 'Select photos to continue',
      selectedOne: '1 photo selected',
      selectedMany: '{count} photos selected',
      voucherNote: 'You are paying for this with your voucher.',
      voucherPartial:
        '{covered} of {total} covered by your voucher · {due} left to pay',
    },
    payment: {
      title: 'Pay at the card terminal',
      waiting: 'Waiting for confirmation',
      voucherFullyCovered: 'Your voucher covers this',
      voucherPartial: 'Voucher: -{discount} · {due} left to pay',
      voucherInvalid: 'Voucher not valid',
    },
    printing: {
      title: 'Your photos are printing now',
      step1: 'Take your photos from the tray',
      step2: 'Take a photo frame from the basket',
      step3: 'Enjoy your memory!',
      eta: 'Ready in about 30 seconds',
    },
    farewell: {
      title: 'Hope to see you again soon!',
    },
    errors: {
      groupsLoadTitle: 'Groups could not be loaded',
      groupsLoadBody: 'Try again or ask a staff member for help.',
      photosNotReadyTitle: 'Photos are not ready yet',
      photosNotReadyBody: 'Wait a moment and scan your ticket again later.',
      ticketNotFoundTitle: 'Ticket not found',
      ticketNotFoundBody: 'Check your ticket or ask a staff member for help.',
      networkErrorTitle: 'Connection failed',
      networkErrorBody: 'Try again or ask a staff member for help.',
      paymentFailedTitle: 'Payment failed',
      paymentFailedBody: 'Try again or ask a staff member for help.',
      paymentDeclinedTitle: 'Card declined',
      paymentDeclinedBody: 'The card was declined. Try another card.',
      paymentInsufficientFundsTitle: 'Not enough funds',
      paymentInsufficientFundsBody:
        'There are not enough funds on the card. Try another card.',
      paymentCardExpiredTitle: 'Card expired',
      paymentCardExpiredBody: 'The card is expired. Try another card.',
      paymentPinRequiredTitle: 'Insert your card',
      paymentPinRequiredBody:
        'This card asks for your PIN. Try again, insert the card in the card terminal and enter your PIN.',
      paymentCardNotAcceptedTitle: 'Card not accepted',
      paymentCardNotAcceptedBody:
        'You cannot use this card here. Try another card.',
      paymentNotCompletedTitle: 'Payment not completed',
      paymentNotCompletedBody: 'The payment is not completed. Try again.',
      paymentReaderUnavailableTitle: 'Card terminal not available',
      paymentReaderUnavailableBody:
        'The card terminal is not available. Ask a staff member for help.',
      paymentTimeoutTitle: 'No payment result',
      paymentTimeoutBody:
        'The card terminal did not send a result in time. Try again.',
      paymentSessionUnavailableTitle: 'Photos not available',
      paymentSessionUnavailableBody:
        'The photos of this group are not available. Ask a staff member for help.',
      paymentRetryExhaustedTitle: 'Payment is not working',
      paymentRetryExhaustedBody: 'Ask a staff member for help.',
      printFailedTitle: 'Printing failed',
      printFailedBody: 'Ask a staff member to check the print job.',
      printFailedPaidBody:
        'We received your payment. Ask a staff member for help.',
      printPartialTitle: '{printed} of {total} photos printed',
      printRefundedBody: 'We refunded {amount} to your card.',
      printNotChargedBody: '{amount} was not charged.',
      printRefundedNotChargedBody:
        'We refunded {refunded} to your card. {notCharged} was not charged.',
      printRetryExhaustedTitle: 'Printing is not working',
      printRetryExhaustedBody: 'Ask a staff member for help.',
      printTimeoutTitle: 'Something went wrong while printing',
      printTimeoutBody: 'Ask a staff member for help.',
      printTimeoutRetryBody:
        'The printer did not send a result in time. Try again or ask a staff member for help.',
    },
    fatal: {
      title: 'Kiosk is restarting',
      subtitle: 'One moment, please.',
      reload: 'Reload',
      staffTitle: 'Tap to call a staff member',
      staffSubtitle: 'The kiosk needs help. Please ask a staff member.',
      misconfiguredTitle: 'Kiosk is misconfigured',
      misconfiguredSubtitle: 'Please ask a staff member for help.',
    },
    system: {
      reconnecting: 'Reconnecting to server…',
    },
  },
} as const;

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = DEFAULT_LOCALE;
}

export function setEntrLocale(locale: EntrLocale): void {
  i18n.global.locale.value = locale;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}
